import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import classnames from "classnames/bind";
import styles from "./categoriesList.module.scss";

const cx = classnames.bind(styles);
const LinkWidget = ({ title, link, selected, disabled, path }) => {
  const classNames = cx("linkWidget", {
    active: selected,
    allCategory: link === "عقارات",
    disabled,
  });

  return (
    <Link href={`${path}/[category]`} as={`${path}/${link}`} shallow>
      <a className={classNames} data-cy={title}>
        {title}
      </a>
    </Link>
  );
};

LinkWidget.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  path: PropTypes.string,
};

LinkWidget.defaultProps = {
  title: "",
  link: "",
  selected: false,
  disabled: false,
  path: "",
};

export default LinkWidget;
